<template>
  <div class="home__about-us__wrapper" id="about-us">
    <div class="home__about-us__wrapper__box">
      <div class="text-content">
        <h2>Witamy w <span class="main">Jadalni</span></h2>
        <p>Stosujemy nowoczesne techniki gotowania, zachowujące zdrowy i naturalny smak
          potraw. Nasze dania bazują na sprawdzonych i nieprzypadkowych składnikach. Korzystamy
          z produktów znanych nam dostawców, wytwarzanych z doświadczeniem, pasją i szacunkiem
          dla naturalności i ekologiczności surowców. Używamy wyłącznie produktów naturalnych
          i mięs zwierząt chowanych w dobrostanie lub żyjących na wolności.</p>
      </div>
      <div class="image">
        <img src="../../assets/img/about-us-image.jpg" alt="About-us-image">
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'AboutUs'
}
</script>
